'use client';

import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

export const useFragment = () => {
  const pathname = usePathname();
  const params = useParams();
  const searchParams = useSearchParams();

  const [fragment, setFragment] = useState<string | undefined>(undefined);

  const hashChangeHandler = useCallback(() => {
    setFragment(window.location.hash);
  }, []);

  useEffect(() => {
    document.addEventListener('click', hashChangeHandler);

    hashChangeHandler();

    return () => {
      document.removeEventListener('click', hashChangeHandler);
    };
  }, [hashChangeHandler, pathname, params, searchParams]);

  return fragment;
};
